/**
*   配置文件
*   zhangxianwen
*   2023-11-22
*/
const CNF = {
    // 'api' : 'http://192.168.3.3:8306/v1/',
    'api' : 'https://api.xinzhiteng.top/teii/v1/',
    'onaiApi' : 'https://api.xinzhiteng.top/onai/v1/',
    // 'onaiApi' : 'http://127.0.0.1:8300/v1/',
    'scmsApi' : 'https://api.xinzhiteng.top/scms/v1/',
    'accountUrl': 'https://seal.xinzhiteng.top/login',
    'userUrl': 'https://seal.xinzhiteng.top/user/security',
    'homeUrl': 'https://home.xinzhiteng.top',
    'projectCode': 'TEII',
    'projectName': '交通设备综合信息管理平台',
    'version': '1.2.2',
    'basename': '',
    'navItems': [
        {'url':'/settings','icon': '','m':1,'name': '基础设置','ptn':'btn_teii_setting','sub':'sub1','submenu':[
            {'url':'/setting/areas','name': '区域设置管理','icon': '','m':11,'ptn':'btn_teii_setting_area'},
        ]},
        {'url':'/intersections','icon': '','m':2,'name': '路口管理','ptn':'btn_teii_intersection','sub':'sub2','submenu':[
            {'url':'/intersections','name': '路口信息管理','icon': '','m':21,'ptn':'btn_teii_intersection'},
            {'url':'/intersection/timings','name': '路口配时管理','icon': '','m':22,'ptn':'btn_teii_intersection_timing'},
            {'url':'/intersection/images','name': '路口图片管理','icon': '','m':23,'ptn':'btn_teii_intersection_image'},
            {'url':'/walkways','name': '行人过街管理','icon': '','m':24,'ptn':'btn_teii_walkway'},
            {'url':'/walkway/images','name': '行人过街图片','icon': '','m':25,'ptn':'btn_teii_walkway_image'},
        ]},
        {'url':'/lines','icon': '','m':3,'name': '线路管理','ptn':'btn_teii_line','sub':'sub3','submenu':[
            {'url':'/lines','name': '线路配置管理','icon': '','m':31,'ptn':'btn_teii_line'},
            {'url':'/line/infos','name': '线路信息管理','icon': '','m':32,'ptn':'btn_teii_line'},
        ]},
        {'url':'/vss','icon': '','m':4,'name': '视频监控','ptn':'btn_teii_vs','sub':'sub4','submenu':[
            {'url':'/vs/devlss','name': '设备直播管理','icon': '','m':41,'ptn':'btn_teii_vs_devls'},
        ]},
        {'url':'/reports','icon': 'message','m':5,'name': '统计报表','ptn':'btn_teii_report','sub':'sub5','submenu':[
            {'url':'/report/intersection/idhmc','name': '路口主机分类占比','icon': '','m':51,'ptn':'btn_teii_report_intersection_idhmc'},
            {'url':'/report/intersection/idinc','name': '路口主机联网占比','icon': '','m':52,'ptn':'btn_teii_report_intersection_idinc'},
            {'url':'/report/intersection/iddec','name': '路口所属支队占比','icon': '','m':53,'ptn':'btn_teii_report_intersection_iddec.bak'},
            {'url':'/report/intersection/idrec','name': '路口所属区域占比','icon': '','m':54,'ptn':'btn_teii_report_intersection_idrec'},
            {'url':'/report/intersection/idstc','name': '路口结构分类占比','icon': '','m':55,'ptn':'btn_teii_report_intersection_idstc'},
            {'url':'/report/intersection/ityec','name': '年度建设数量走势','icon': '','m':56,'ptn':'btn_teii_report_intersection_ityec'},
            {'url':'/report/intersection/idopc','name': '网络厂商分类占比','icon': '','m':57,'ptn':'btn_teii_report_intersection_idopc'},
        ]},
        {'url':'/logs','icon': '','m':6,'name': '日志管理','ptn':'btn_teii_log','sub':'sub6','submenu':[
            {'url':'/log/operations','name': '操作日志管理','icon': '','m':61,'ptn':'btn_teii_log_operation'},
            {'url':'/log/timings','name': '配时日志管理','icon': '','m':62,'ptn':'btn_teii_log_timing'},
        ]}
    ],
    'headerAuthKey': 'x-auth',
    'cookies': {
        'keySecure': true,
        'keyPath': '/',
        'keyDomain': '.xinzhiteng.top',
        'keyExpire': 86400,
        'keyUid': 'login_smtants_uid',
        'keyId': 'login_smtants_id',
        'keyToken': 'login_smtants_token',
        'keyUsername': 'login_smtants_username',
        'keyDisplayname': 'login_smtants_displayname'
    },
    'pageSize': 10,   
    'status': [
        {'key': '激活', 'value': 1},
        {'key': '禁用', 'value': 2}
    ],
    'deviceStatus': [
        {'key': '在线', 'value': 1},
        {'key': '离线', 'value': 2}
    ],
    'lsUrlType': [
        {'key': '源', 'value': 'bind'},
        {'key': 'flv', 'value': 'flv'},
        {'key': 'rtmp协议', 'value': 'rtmp'}
    ],
    'modules': ['SETTING_AREA','INTERSECTION','INTERSECTION_TIMING','INTERSECTION_IMAGE','VS_DEVLS'],
    'actions': ['CREATE', 'UPDATE', 'DELETE', 'IMPORT','ACTIVE', 'DISABLE'],
    'brands': ['东川','金科','海信','杰瑞','德安','大华'],
    'themes': [
        {'name':'靛青蓝','number': 1,'lineColor': '#235495','tbgColor':'#033448','cbgColor': '#033448'},
        {'name':'极光蓝','number': 2,'lineColor': '#223277','tbgColor':'#010B3A','cbgColor': '#020F3A'}
    ]
}

export default CNF;